import {computed} from "vue";
import {storeToRefs} from "pinia";
import {useSystemStore} from "@/stores/system.store";

/**
 * Composable exposing the current organization id from the loaded
 * environment. Null until the environment is loaded.
 */
const useOrganizationId = () => {
    const {environment} = storeToRefs(useSystemStore());

    return computed(() => environment.value?.organizationId ?? null);
};

export default useOrganizationId;
